import React from "react";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";

import { GreaterThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";
import {
    IfThenExpression,
    IfThenStyle,
} from "../../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { MultiplyExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/MultiplyExpression";
import { StringLengthExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringLengthExpression";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ObjectDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { LessThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/LessThanExpression";
import { XExecutableTester } from "../XExecutableTester";
import { getIfElseSimpleRule } from "../../../Expressions/Testing/LogicData";
import { StoryNode } from "../../StoryBook/StoryData";
import { OrGroup } from "../../../rule-engine-core/Expressions/Expressions/Logic/OrGroup";

function getIfThenExpression() {
    let exp = new ExpressionConfiguration();
    let baseExpression = new IfThenExpression();
    baseExpression.ifThenStyle = IfThenStyle.BRANCH_DATA_RETURN;
    baseExpression.showElseAsDefault = true;

    baseExpression.ifBranches[0].ifExpression.elements[0].variableName = "isEmployee";
    let subExpression = new MultiplyExpression();
    subExpression.value2.value = 10;
    subExpression.value1.variableName = "income";
    baseExpression.ifBranches[0].thenExpression.subExpression = subExpression;

    let greaterThan = new GreaterThanExpression();
    let strLen = new StringLengthExpression();

    strLen.value1.variableName = "person.name";
    greaterThan.value1.subExpression = strLen;
    greaterThan.value2.value = 5;

    let secondIf = baseExpression.addIfBranch();

    secondIf.ifExpression = new OrGroup();

    secondIf.ifExpression.elements[0].subExpression = greaterThan;

    let lessThan = new LessThanExpression();
    lessThan.value1.variableName = "age";
    lessThan.value2.value = 40;
    secondIf.ifExpression.add();

    secondIf.ifExpression.elements[1].subExpression = lessThan;
    secondIf.thenExpression.value = 1000;

    baseExpression.defaultOutput.value = 0;
    exp.expression = baseExpression;

    return exp;
}

let datadef = new DataDefinition();
datadef.fields.push(new BooleanDataDefinition("isEmployee"));
datadef.fields.push(new NumberDataDefinition("income"));
datadef.fields.push(new NumberDataDefinition("age"));
datadef.fields.push(new BooleanDataDefinition("isContractor"));
let personfield = new ObjectDataDefinition("person");
personfield.fields.push(new StringDataDefinition("name"));
datadef.fields.push(personfield);

export const ExpressionTester = [
    new StoryNode(
        () => {
            let expression = getIfThenExpression();
            expression.inputData = datadef;
            expression.executionResult = () => new NumberDataDefinition();

            return <XExecutableTester executable={expression} />;
        },
        "Shared",
        "Tester",
        "Expression",
        "Default Return",
    ),
    new StoryNode(
        () => {
            function getLogicExpressionResultElseIfAtEnd(): ExpressionConfiguration {
                let exp = new ExpressionConfiguration();
                exp.executionResult = new NumberDataDefinition();

                let baseExpression = new IfThenExpression();
                baseExpression.ifThenStyle = IfThenStyle.DATA_RETURN;

                baseExpression.ifBranches[0].ifExpression.elements[0].variableName = "isEmployee";

                let greaterThan = new GreaterThanExpression();
                let strLen = new StringLengthExpression();
                strLen.value1.variableName = "person.name";

                greaterThan.value1.subExpression = strLen;
                greaterThan.value2.value = 5;

                let secondIf = baseExpression.addIfBranch();

                secondIf.ifExpression.elements[0].subExpression = greaterThan;
                secondIf.thenExpression.value = 20;

                // true result
                let subExpression = new MultiplyExpression();
                subExpression.value2.value = 10;
                subExpression.value1.variableName = "income";
                baseExpression.trueOutput.subExpression = subExpression;

                // false result
                baseExpression.defaultOutput.variableName = "income";

                exp.expression = baseExpression;

                exp.executionResult = () => new NumberDataDefinition();

                return exp;
            }

            let expression = getLogicExpressionResultElseIfAtEnd();
            expression.inputData = datadef;

            return <XExecutableTester executable={expression} />;
        },
        "Shared",
        "Tester",
        "Expression",
        "Data Return",
    ),
    new StoryNode(
        () => {
            let expression = getIfElseSimpleRule();
            expression.inputData = datadef;
            expression.executionResult = () => new NumberDataDefinition();
            return <XExecutableTester executable={expression} />;
        },
        "Shared",
        "Tester",
        "Expression",
        "Logic Return",
    ),
];
